const VISITOR_SESSION_STORAGE_KEY = 'qumashi-visitor-session';

/** Stable anonymous id per browser profile (incognito gets its own until closed). */
export function getOrCreateVisitorSessionKey(): string {
  try {
    const existing = globalThis.localStorage?.getItem(VISITOR_SESSION_STORAGE_KEY);
    if (existing && existing.length >= 8) {
      return existing;
    }
    const created =
      typeof globalThis.crypto?.randomUUID === 'function'
        ? globalThis.crypto.randomUUID()
        : `v-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
    globalThis.localStorage?.setItem(VISITOR_SESSION_STORAGE_KEY, created);
    return created;
  } catch {
    return `v-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  }
}
